import React, {Component} from 'react';
import {connect} from 'react-redux';
import classnames from 'classnames';
import querystring from 'querystring';
import {selectItem, receiveItems, deselectItem, updateItem} from '../../../actions/comment/commentTrash';

import ItemCheckbox from "../../common/CommentItemCheckbox";
import {ipMasking} from '../../../utils/formatter';
import * as RoleType from "../../../constants/user/RoleType";
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import {Link} from 'react-router-dom'
import * as InitStatus from '../../../constants/common/InitializationStatus';
import {addPrefix} from "../../../utils/UriUtil";


function Title(props) {
  const {item} = props;
  return <strong className="tit_post">
            <span className="link_cont">
              {item.comment}
            </span>
  </strong>
}

function Author(props) {
  const {item} = props;
  const escapeAtChar = item.author.substring(1, item.author.length);
  return <Link to={"/comments/trash?" + querystring.stringify(Object.assign({}, {searchKeyword: escapeAtChar, searchType: 'writer'}))}><span className="txt_cate">{item.author}</span></Link>;
}


@connect(state => ({
  currentUserRole: state.user.role,
}), dispatch => ({
  handleSelectItem: (id) => {
    dispatch(selectItem(id))
  },
  handleReceiveItems: (items, totalCount) => {
    dispatch(receiveItems(items, totalCount))
  },
  handleDeselectItem: (id) => {
    dispatch(deselectItem(id))
  },
  handleUpdateItem: (item) => {
    dispatch(updateItem(item))
  },
  dispatch
}))
class CommentTrashListItem extends Component {

  constructor(props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this);
    this.handleRestore = this.handleRestore.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.reFetchItems = this.reFetchItems.bind(this);

    this.state = {
      initStatus: InitStatus.INIT_READY
    }
  }

  handleSelect(e) {
    const {item, handleSelectItem, handleDeselectItem} = this.props;

    if (item.selected) {
      handleDeselectItem(item.id)
    } else {
      handleSelectItem(item.id)
    }
  }

  handleRemove(e, item) {
    e.preventDefault();

    const {currentUserRole, handleUpdateItem, dispatch} = this.props;
    const hasRole = RoleType.canAccess(RoleType.convertStringToRoleType(currentUserRole), RoleType.EDITOR);
    let canManage = !(!item.editable || !hasRole);

    if (!canManage) {
      alert('편집자 이상의 권한이 필요합니다.');
    } else {

      if (confirm('선택한 댓글을 완전히 삭제하시겠습니까?')) {
        item.deleting = true;
        this.setState({initStatus: InitStatus.INIT_DOING});

        handleUpdateItem(item);
        fetch(addPrefix("/manage/commentTrash/" + item.id + ".json"), {
          method: "delete",
          credentials: "include",
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        })
          .then(jsonResponseHandler(dispatch))
          .then(data => {
            this.reFetchItems();
            this.setState({initStatus: InitStatus.INIT_SUCCESS});
          })
          .catch(e => {
            item.deleting = false;
            this.setState({initStatus: InitStatus.INIT_FAIL});
            handleUpdateItem(item);
            console.log(e)
          })

      }
    }
  }

  handleRestore(e, item) {
    e.preventDefault();

    const {currentUserRole, dispatch} = this.props;
    const hasRole = RoleType.canAccess(RoleType.convertStringToRoleType(currentUserRole), RoleType.EDITOR);
    let canManage = !(!item.editable || !hasRole);

    if (!canManage) {
      alert('편집자 이상의 권한이 필요합니다.');
    } else {

      this.setState({initStatus: InitStatus.INIT_DOING});
      fetch(addPrefix("/manage/commentTrash/" + item.id + "/restore.json"), {
        method: "put",
        credentials: "include",
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      })
        .then(jsonResponseHandler(dispatch))
        .then(data => {
          this.reFetchItems();
          this.setState({initStatus: InitStatus.INIT_SUCCESS});
        })
        .catch(e => {
          console.log(e)
          this.setState({initStatus: InitStatus.INIT_FAIL});
        })

    }
  }

  reFetchItems() {

    const {handleReceiveItems, dispatch} = this.props;

    fetch(addPrefix("/manage/commentTrash.json" + location.search), {
      method: 'GET',
      credentials: 'include'
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        handleReceiveItems(data.items, data.totalCount);
      })
      .catch(e => {
        console.log(e)
      })
  }

  render() {
    const {item, currentUserRole} = this.props;
    const hasRole = RoleType.canAccess(RoleType.convertStringToRoleType(currentUserRole), RoleType.EDITOR);
    const canManage = !(item.deleting || !item.editable || !hasRole);
    const isDoing = this.state.initStatus == InitStatus.INIT_DOING;

    return (
      <li className={classnames({item_dimmed: isDoing})}>
        <ItemCheckbox item={item} handleSelect={this.handleSelect}/>
        <div className="post_cont">
          <Author item={item}/>
          <span className="txt_info fst">{ipMasking(item.ip)}</span>
          <span className="txt_info">{item.written}</span>
          <Title item={item}/>
          <span className="txt_info txt_ellip fst"><span className="ico_blog ico_post"/>{item.entryTitle}</span>
        </div>
        {!isDoing &&
        <div className="post_btn post_btn_type1">
          <div className="info_btn">
            <a href="#" className={classnames("btn_post", {disable: !canManage})} onClick={(e) => this.handleRestore(e, item)}>복구</a>
            <a href="#" className="btn_post" onClick={(e) => this.handleRemove(e, item)}>삭제</a>
          </div>
        </div>
        }
      </li>
    );
  }
}

export default CommentTrashListItem;
